<div [formGroup]="formSearch">
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Codigo tg</mat-label>
      <input matInput formControlName="tgCode" />
    </mat-form-field>

    <!--    <mat-form-field-->
    <!--      class="input-tg search-tg no-message-new w-3/12"-->
    <!--      appearance="outline"-->
    <!--    >-->
    <!--      <mat-label>Status</mat-label>-->
    <!--      <mat-select formControlName="status">-->
    <!--        @for (item of listStatus; track item) {-->
    <!--          <mat-option [value]="item.id">{{ item.description }}</mat-option>-->
    <!--        }-->
    <!--      </mat-select>-->
    <!--    </mat-form-field>-->

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Data inicio</mat-label>
      <input
        matInput
        [matDatepicker]="dateStart"
        (focus)="openDatepicker('dateStart')"
        formControlName="dateStart"
        readonly
        [max]="formSearch.get('dateEnd')!.value"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateStart"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Sub cliente</mat-label>
      <input matInput formControlName="subClient" />
    </mat-form-field>
  </div>
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Evento</mat-label>
      <input matInput formControlName="event" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Data fim</mat-label>
      <input
        matInput
        [matDatepicker]="dateEnd"
        (focus)="openDatepicker('dateEnd')"
        formControlName="dateEnd"
        readonly
        [min]="formSearch.get('dateStart')!.value"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateEnd"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateEnd></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Cliente</mat-label>
      <input matInput formControlName="client" />
    </mat-form-field>

    <!--    <mat-form-field-->
    <!--      class="input-tg search-tg no-message-new w-3/12"-->
    <!--      appearance="outline"-->
    <!--    >-->
    <!--      <mat-label>Consultor cliente</mat-label>-->
    <!--      <input matInput formControlName="consultantClient" />-->
    <!--    </mat-form-field>-->

    <!--    <mat-form-field-->
    <!--      class="input-tg search-tg no-message-new w-3/12"-->
    <!--      appearance="outline"-->
    <!--    >-->
    <!--      <mat-label>Consultor comercial</mat-label>-->
    <!--      <input matInput formControlName="consultantTg" />-->
    <!--    </mat-form-field>-->
  </div>

  <div class="mb-3 flex justify-end items-center gap-2">
    <button
      class="btn-icon"
      (click)="sendSearch(false)"
      [matTooltip]="'Limpar Pesquisar'"
    >
      <mat-icon>replay</mat-icon>
    </button>
    <button class="btn-icon" (click)="sendSearch()" [matTooltip]="'Pesquisa'">
      <mat-icon>search</mat-icon>
    </button>
  </div>
</div>
